"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Video = void 0;
var react_1 = __importDefault(require("react"));
exports.Video = react_1["default"].forwardRef(function (_a, ref) {
    var autoPlay = _a.autoPlay, cssNamespace = _a.cssNamespace, muted = _a.muted, loop = _a.loop, style = _a.style;
    return (react_1["default"].createElement("video", { style: style, className: cssNamespace + "__video", autoPlay: autoPlay, muted: muted, ref: ref, loop: loop }));
});
